module.exports = __webpack_public_path__ + "img/email.47d8a8d0.svg";